import * as filepath from './filepath';
import * as strings from './strings';

export const ExtWebSafe = new Set([
    '.bmp',
    '.gif',
    '.jpg',
    '.jpeg',
    '.png',
    '.ico',
]);

export function GetProofURLs(cloudFront: string, file: string, path: string): { main: string; thumb: string } {
    const ret = { main: '', thumb: '' };

    const ext = filepath.Ext(file).toLowerCase();
    if (path) {
        if (!ExtWebSafe.has(ext)) {
            ret.main = cloudFront + '/' + strings.TrimLeft(path, '/') + '/main.png';
        } else {
            ret.main = cloudFront + '/' + strings.TrimLeft(file, '/');
        }
        ret.thumb = cloudFront + '/' + strings.TrimLeft(path, '/') + '/thumb.png';
    } else if (!ExtWebSafe.has(ext)) {
        return ret;
    } else {
        ret.main = cloudFront + '/' + strings.TrimLeft(file, '/');
        ret.thumb = ret.main;
    }
    return ret;
}
